import {
  INSTANCE_URL,
  FILES_URL,
  OFFSET_LIMIT_20
} from '../../Common/constant';
import {
  getRequest,
  postRequest,
  uploadEncodedFile
} from '../../Common/network-call';
import _ from 'lodash';

export const MY_BOOKED_EXHIBITOR = 'MY_BOOKED_EXHIBITOR';
export const FETCH_EXHIBITORS = 'FETCH_EXHIBITORS';
export const SETEXHIBITORDETAILS = 'SETEXHIBITORDETAILS';
export const FETCH_EXHIBITOR_DETAILS = 'FETCH_EXHIBITOR_DETAILS';
export const FETCH_EXB_CHAT_DETAILS = 'FETCH_EXB_CHAT_DETAILS';
export const SHOW_ONLY_EXHIBITOR_DETAILS = 'SHOW_ONLY_EXHIBITOR_DETAILS';
export const FETCH_EXB_COUNTRY = 'FETCH_EXB_COUNTRY';
export const FETCH_EXB_SECTORS = 'FETCH_EXB_SECTORS';
export const FETCH_EXB_CATEGORIES = 'FETCH_EXB_CATEGORIES';

export const fetchBookedExhibitors = (session, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(appuserid=${session.userid})AND(type=exhibitor)`
  );
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/bookmarks?include_count=true&fields=bookmarkid,typeid&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      response => {
        dispatch({
          type: MY_BOOKED_EXHIBITOR,
          payload: { resource: response.resource, count: response.meta.count }
        });
        callback({
          success: 1,
          resource: response.resource,
          count: response.meta.count
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchAllExhibitor = (session, middleWares, callback) => {
  // --- middleWares is a object that has all the surplus params
  let pageCount = middleWares.pagecount ?? 0; // for offset calculation
  let actionType = middleWares.type ?? ''; // 'search'/''/'country'/'industry'/'subcategory'/'redirection'
  let searchTerm = middleWares.term ?? ''; // keyword to search / country name / industry name / subcategory array
  let sortBy = middleWares.sort ?? 'az'; // DEFAULT 'az'(name) / 'randomly'(create) / 'booth'
  let dataArr = middleWares.data ?? []; // previous fetched collection to concat upon
  let reRender = middleWares.rerender ?? false; // true if re-render of list needed
  let selectedExhibitorId = middleWares.id ?? null; // bookmarked / selected exhibitor id to filter
  let chunkDataArr =
    reRender && middleWares?.data?.length ? _.chunk(middleWares.data, 20) : [];
  let bookmarkAction = middleWares.action ?? ''; // bookmark action

  // --- pagination handling
  let perPage = OFFSET_LIMIT_20;
  if (reRender && selectedExhibitorId && chunkDataArr.length) {
    _.map(chunkDataArr, (chunkItem, chunkIndex) => {
      let filterChunk = _.filter(
        chunkItem,
        exhItem => exhItem.exhibitorid == selectedExhibitorId
      );

      if (filterChunk.length) pageCount = chunkIndex + 1;
    });
  }
  let offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  let offSetQuery = `limit=${perPage}&offset=${offset}`;

  // --- param handling
  let fetchFilter = encodeURI(`eventid=${session.eventid}`);
  if (actionType == 'subcategory' && !_.isEmpty(searchTerm)) {
    let inStr = '( ';
    _.map(searchTerm, (item, index) => {
      if (index == searchTerm.length - 1) {
        inStr += item + ' )';
      } else {
        inStr += item + ', ';
      }
    });

    fetchFilter = encodeURI(
      `(eventid=${session.eventid})AND(exhibitorid IN ${inStr})`
    );
  } else if (searchTerm !== '') {
    fetchFilter =
      actionType == 'search'
        ? encodeURI(
            `(eventid=${session.eventid})AND((name CONTAINS ${searchTerm})OR(booth CONTAINS ${searchTerm}))`
          )
        : actionType == 'country'
        ? encodeURI(`(eventid=${session.eventid})AND(country=${searchTerm})`)
        : encodeURI(`(eventid=${session.eventid})AND(industry=${searchTerm})`);
  }
  let orderBy =
    actionType != ''
      ? 'name%20ASC'
      : sortBy === 'randomly'
      ? 'createdon%20DESC'
      : sortBy === 'booth'
      ? 'booth%20ASC'
      : 'name%20ASC';

  let fetchUrl = `${INSTANCE_URL}/api/v2/eventify/_table/exhibitors?include_count=true&related=appuser_by_exhibitoridfk&filter=(${fetchFilter})&order=${orderBy}&${offSetQuery}`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      response => {
        let responseArr = response.resource;

        // --- bookmark handling
        _.map(responseArr, (exhItem, resourceIndex) => {
          let itemObj = exhItem;

          // - if coming for rerender with selected item id setting key bool value acc. to action
          if (
            selectedExhibitorId &&
            exhItem.exhibitorid == selectedExhibitorId &&
            bookmarkAction != ''
          )
            itemObj.isBookMarked = bookmarkAction == 'unmark' ? false : true;
          else itemObj.isBookMarked = false;

          responseArr[resourceIndex] = itemObj;
        });

        // --- sorting for booth
        if (sortBy === 'booth') {
          let boothNos = _.filter(responseArr, obj => {
            return obj?.booth;
          });
          let notBooth = _.filter(responseArr, obj => {
            return !obj.booth || obj.booth == '';
          });
          if (notBooth.length > 0) {
            boothNos = _.concat(boothNos, notBooth);
          }
          responseArr = boothNos;
        }

        // --- redirection actionType section
        if (actionType == 'redirection' && selectedExhibitorId) {
          let filterExh = _.filter(
            responseArr,
            exh => exh.exhibitorid == selectedExhibitorId
          );
          dispatch(
            fetchExhibitorDetails(session, selectedExhibitorId, detailsRes => {
              if (detailsRes.details) {
                dispatch(setExhibitor(detailsRes.details));
                if (!filterExh.length)
                  responseArr = _.concat(detailsRes.details, responseArr);
              }
            })
          );
        }

        // --- payload creation and dispatches
        let payloadObj = {
          count: response.meta.count
        };
        if (reRender) {
          chunkDataArr[pageCount <= 1 ? 0 : pageCount - 1] = responseArr;
          payloadObj.resource = _.flatten(chunkDataArr);
        } else payloadObj.resource = dataArr.concat(responseArr);

        dispatch({
          type: FETCH_EXHIBITORS,
          payload: payloadObj
        });
        callback({
          ...payloadObj,
          success: 1
        });
      },
      error => {
        callback({
          success: 0,
          message: error
        });
      }
    );
  };
};

export const fetchExhibitorDetails = (session, exhibitorid, callback) => {
  const url = `${INSTANCE_URL}/api/v2/eventifyscript/exhibitordetails`;
  const body = {
    eventid: session.eventid,
    appuserid: session.userid,
    exhibitorid
  };

  let table_filter = encodeURI(
    `(eventid=${session.eventid})AND(exhibitorid=${exhibitorid})`
  );
  let table_url = `${INSTANCE_URL}/api/v2/eventify/_table/exhibitors?related=appuser_by_exhibitoridfk,interactivemaps_by_interactivemaplocation_exhibitor_link&filter=(${table_filter})`;

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        getRequest(
          table_url,
          session,
          dispatch,
          res => {
            if (res.resource.length > 0) {
              dispatch({
                type: FETCH_EXHIBITOR_DETAILS,
                payload: { ...response.data, details: res.resource[0] }
              });
              callback({ ...response.data, details: res.resource[0] });
            } else {
              dispatch({
                type: FETCH_EXHIBITOR_DETAILS,
                payload: response.data
              });
              callback(response.data);
            }
          },
          error => {
            dispatch({ type: FETCH_EXHIBITOR_DETAILS, payload: response.data });
            callback(response.data);
          }
        );
      },
      error => {}
    );
  };
};

export const fetchExbCountry = (session, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(country != '')AND(country != ${null})`
  );
  let groupby = 'country%20ASC';
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/exhibitors?include_count=true&fields=country&filter=(${filter})&group=${groupby}`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: FETCH_EXB_COUNTRY,
          payload: { data: data.resource, count: data.resource.length }
        });
        callback({
          success: 1,
          result: { response: data.resource }
        });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
};

export const fetchExbSectors = (session, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(industry != '')AND(industry != ${null})`
  );
  let groupby = 'industry%20ASC';
  let fields = 'industry';
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/exhibitors?include_count=true&fields=${fields}&filter=(${filter})&group=${groupby}`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: FETCH_EXB_SECTORS,
          payload: { data: data.resource, count: data.resource.length }
        });
        callback({
          success: 1,
          result: { response: data.resource }
        });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
};

export const fetchExbCategories = (session, callback) => {
  let filter = encodeURI(
    `(eventid=${
      session.eventid
    })AND(subcategory != '')AND(subcategory != ${null})`
  );
  // let groupby = '';
  let fields = 'exhibitorid,category,subcategory';
  // let url = `${INSTANCE_URL}/api/v2/eventify/_table/exhibitor_products?include_count=true&fields=${fields}&filter=(${filter})&group=${groupby}`;
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/exhibitor_products?include_count=true&fields=${fields}&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        // console.log('fetchExbCategories data: ', data);
        const groupByCategory = _.groupBy(data.resource, 'category');
        // console.log('groupByCategory: ', groupByCategory);

        let groupByCategorySubCategory = [];
        for (const key in groupByCategory) {
          const value = groupByCategory[key];
          const groupBySubCategory = _.groupBy(value, 'subcategory');

          let subcategory = [];
          for (const keySubcategory in groupBySubCategory) {
            const valueSubcategory = groupBySubCategory[keySubcategory];

            let data = [];
            _.map(valueSubcategory, item => {
              data.push(item.exhibitorid);
            });

            subcategory.push({
              subcategory: keySubcategory,
              data: data
            });
          }

          groupByCategorySubCategory.push({
            category: key,
            subcategory: subcategory
          });

          // console.log(key, value);
        }
        // console.log('groupByCategorySubCategory: ', groupByCategorySubCategory);

        dispatch({
          type: FETCH_EXB_CATEGORIES,
          payload: {
            data: groupByCategorySubCategory,
            count: groupByCategorySubCategory.length
          }
        });
        callback({
          success: 1,
          result: { response: groupByCategorySubCategory }
        });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
};

export const fetchExhibitorAnalytics = (session, exhibitorid, callback) => {
  let url = `${INSTANCE_URL}/api/v2/analytics?type=exhibitorsallhits`;
  let body = {
    eventid: session.eventid,
    id: exhibitorid
  };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // console.log('fetch response: ', response);
        callback({
          success: 1,
          data: response.result,
          message: response.message
        });
      },
      error => {
        callback({ success: 0, error });
      }
    );
  };
};

// --- clear redux starts
export const clearAllExhibitor = () => {
  return dispatch => {
    dispatch({ type: FETCH_EXHIBITORS, payload: {} });
  };
};

export const clearExhibitorDetails = () => {
  return dispatch => {
    dispatch({ type: FETCH_EXHIBITOR_DETAILS, payload: {} });
  };
};
// --- clear redux ends

// --- set redux no call starts
export const setExhibitor = exhibitor => {
  return dispatch => {
    dispatch({ type: SETEXHIBITORDETAILS, payload: exhibitor });
  };
};

export const setAllExhibitor = allExhibitor => {
  return dispatch => {
    dispatch({ type: FETCH_EXHIBITORS, payload: allExhibitor });
  };
};

export const showOnlyExhibitorDetails = bool => {
  return dispatch => {
    dispatch({ type: SHOW_ONLY_EXHIBITOR_DETAILS, payload: bool });
  };
};
// --- set redux no call ends

// --- TODO: remove thhis to common or src/actions and update app accordingly
export const uploadMedia = (session, uploadFiles, callback) => {
  // console.log('uploadFiles', uploadFiles);

  if (uploadFiles?.file) {
    let filecontent = uploadFiles.file.split(';base64,')[1]; // for all type of file
    let filename = `eventify/${session.eventid}/images/appuser/notes/${uploadFiles.name}`;

    let mediaJson = {
      resource: [
        {
          name: filename,
          type: 'file',
          is_base64: true,
          content: filecontent
        }
      ]
    };
    return dispatch => {
      uploadEncodedFile(
        `${FILES_URL}?check_exist=false`,
        session,
        mediaJson,
        dispatch,
        response => {
          // console.log('response uploadMedia action: ', response);
          callback({ success: 1, data: response });
        },
        error => {
          callback({ success: 0, message: error });
        }
      );
    };
  } else {
    return dispatch => {
      callback({ success: 1 });
    };
  }
};

// ----- these actions are not needed from now on - 18/1/23
// All these seperate calls are now combined in one action fetchAllExhibitor by Anubhab
// export const fetchAllExhibitorByCountry = (session, country, callback) => {
//   let filter = encodeURI(`(eventid=${session.eventid})AND(country=${country})`);
//   // let orderby = 'createdon%20DESC';
//   let orderby = 'name%20ASC';
//   let url = `${INSTANCE_URL}/api/v2/eventify/_table/exhibitors?include_count=true&related=appuser_by_exhibitoridfk&filter=(${filter})&order=${orderby}`;

//   return dispatch => {
//     fetchAndFilterByBookMark(url, session, 'exhibitor', dispatch, response => {
//       // console.log('response: ', response);
//       dispatch({
//         type: FETCH_EXHIBITORS,
//         payload: { resource: response.resource, count: response.meta.count }
//       });
//       callback({
//         success: 1,
//         resource: response.resource,
//         count: response.meta.count
//       });
//     });
//   };
// };

// export const fetchAllExhibitorBySectors = (session, industry, callback) => {
//   let filter = encodeURI(
//     `(eventid=${session.eventid})AND(industry=${industry})`
//   );
//   // let orderby = 'createdon%20DESC';
//   let orderby = 'name%20ASC';
//   let url = `${INSTANCE_URL}/api/v2/eventify/_table/exhibitors?include_count=true&related=appuser_by_exhibitoridfk&filter=(${filter})&order=${orderby}`;

//   return dispatch => {
//     fetchAndFilterByBookMark(url, session, 'exhibitor', dispatch, response => {
//       // console.log('response: ', response);
//       dispatch({
//         type: FETCH_EXHIBITORS,
//         payload: { resource: response.resource, count: response.meta.count }
//       });
//       callback({
//         success: 1,
//         resource: response.resource,
//         count: response.meta.count
//       });
//     });
//   };
// };

// export const fetchAllExhibitorBySubCategories = (session, data, callback) => {
//   let inStr = '( ';
//   _.map(data, (item, index) => {
//     if (index == data.length - 1) {
//       inStr += item + ' )';
//     } else {
//       inStr += item + ', ';
//     }
//   });

//   let filter = encodeURI(
//     `(eventid=${session.eventid})AND(exhibitorid IN ${inStr})`
//   );
//   // let orderby = 'createdon%20DESC';
//   let orderby = 'name%20ASC';
//   let url = `${INSTANCE_URL}/api/v2/eventify/_table/exhibitors?include_count=true&related=appuser_by_exhibitoridfk&filter=(${filter})&order=${orderby}`;

//   return dispatch => {
//     fetchAndFilterByBookMark(url, session, 'exhibitor', dispatch, response => {
//       // console.log('response: ', response);
//       dispatch({
//         type: FETCH_EXHIBITORS,
//         payload: { resource: response.resource, count: response.meta.count }
//       });
//       callback({
//         success: 1,
//         resource: response.resource,
//         count: response.meta.count
//       });
//     });
//   };
// };

// export const searchExhibitor = (session, keywords, callback) => {
//   let filter = encodeURI(
//     `(eventid=${session.eventid})AND((name CONTAINS ${keywords})OR(booth CONTAINS ${keywords}))`
//   );
//   // let orderby = 'createdon%20DESC';
//   let orderby = 'name%20ASC';
//   let url = `${INSTANCE_URL}/api/v2/eventify/_table/exhibitors?include_count=true&related=appuser_by_exhibitoridfk&filter=(${filter})&order=${orderby}`;

//   return dispatch => {
//     fetchAndFilterByBookMark(url, session, 'exhibitor', dispatch, response => {
//       // console.log('response: ', response);
//       dispatch({
//         type: FETCH_EXHIBITORS,
//         payload: { resource: response.resource, count: response.meta.count }
//       });
//       callback({
//         success: 1,
//         resource: response.resource,
//         count: response.meta.count
//       });
//     });
//   };
// };

// export const fetchAllExhibitor = (session, sortby = 'az', callback) => {
//   let filter = encodeURI(`eventid=${session.eventid}`);
//   let orderby =
//     sortby === 'randomly'
//       ? 'createdon%20DESC'
//       : sortby === 'booth'
//       ? 'booth%20ASC'
//       : 'name%20ASC';
//   let url = `${INSTANCE_URL}/api/v2/eventify/_table/exhibitors?include_count=true&related=appuser_by_exhibitoridfk&filter=(${filter})&order=${orderby}&limit=20`;

//   return dispatch => {
//     fetchAndFilterByBookMark(url, session, 'exhibitor', dispatch, response => {
//       // console.log('response: ', response);

//       // this section is to just keep the blank or null booth no in bottom of the arrar.
//       if (sortby === 'booth') {
//         let boothNos = _.filter(response.resource, obj => {
//           return obj?.booth;
//         });
//         let notBooth = _.filter(response.resource, obj => {
//           return !obj.booth || obj.booth == '';
//         });
//         if (notBooth.length > 0) {
//           boothNos = _.concat(boothNos, notBooth);
//         }
//         response.resource = boothNos;
//       }

//       dispatch({
//         type: FETCH_EXHIBITORS,
//         payload: { resource: response.resource, count: response.meta.count }
//       });
//       callback({
//         success: 1,
//         resource: response.resource,
//         count: response.meta.count
//       });
//     });
//   };
// };
// ---
